@if (userId !== null) {
    <div class="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 wk-suem__container" [class.noActive]="!userModel.Active">
        <div class="wk-suem__warning">
            <div class="fa fa-warning"></div>
            <div class="wk-suem__warning-content">
                <div class="wk-suem__warning-title">{{ "Settings.Warning" | translate }}</div>
                <div>{{ "UserManagement.LegacyOptionWarning" | translate }}</div>
            </div>
        </div>

        @if (userId !== "new" && !currentUser) {
            <div class="wk-suem__account">
                <div class="wk-suem__account-title">{{ "Settings.UserAccountTitle" | translate }}</div>
                <div class="wk-suem__account-text">
                    {{ (userModel.Active ? "Settings.DisableUserAccountText" : "Settings.EnableUserAccountText") | translate }}
                </div>
                <div class="wk-suem__account__actions">
                    <div
                        [class.active]="userModel.Active"
                        class="wk-suem__account__actions-button wk-suem__account__actions-enable"
                        (click)="enableUser()"
                    >
                        {{ "Settings.EnableUserAccount" | translate }}
                    </div>
                    <div
                        [class.active]="!userModel.Active"
                        class="wk-suem__account__actions-button wk-suem__account__actions-disable"
                        (click)="disableUser()"
                    >
                        {{ "Settings.DisableUserAccount" | translate }}
                    </div>
                </div>
            </div>
        }
    </div>
}
